import { get } from '@kit/utils/APIV1.js'

export const jobPage = async(whichOne) => {
  return get(`job-page/slug/${whichOne}`)
}